<template lang="pug">
transition(name="fade-delay")
    div(v-show="$nuxt.isOffline && !closed" class="fixed w-full bg-danger-dark p-2 text-center z-third-party text-white font-bold transition-colors duration-200 ease")
        | Connection: Offline
        XIcon(@click="closed = !closed" class="close-icon fill-current text-white")
</template>

<script>
import XIcon from '@/assets/common/x?inline'

export default {
    name: 'Offline',
    components: { XIcon },
    data() {
        return {
            closed: false,
        }
    },
}
</script>

<style lang="stylus" scoped>
.fade-delay-enter-active
    animation fade .25s

.fade-delay-leave-active
    animation fade .5s reverse .5s

@keyframes fade
    0% { opacity: 0 }
    100% { opacity: 1 }
</style>
